import React from "react";
import Top from "../../Top";
import Left from "../../Left";
// import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
// import CreateIcon from "@mui/icons-material/Create";
// import DeleteIcon from "@mui/icons-material/Delete";
import Zoom from "react-medium-image-zoom";
// import Switch from "@mui/material/Switch";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
import MicIcon from "@mui/icons-material/Mic";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import AmenitiesModal from "./AmenitiesModal";
// import AllAmenities from "./AllAmenities";
// End

// import { useEffect, useMemo } from "react";
import { makePostRequest } from "../../../utils/utils";
import swal from "sweetalert";

// For Tab
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// End

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// const label = { inputProps: { "aria-label": "Size switch demo" } };

function BookedAmenities() {
  // const navigate = useNavigate();

  // For Tab
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  // End

  // For memu
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const open2 = Boolean(anchorEl);

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose2 = () => {
  //   setAnchorEl(null);
  // };
  // End

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");

  const [amenitiesList, setAmenitiesList] = React.useState([]);

  // const handleClickOpen = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };
  const handleClose = () => {
    setOpen(false);
  };
  const descriptionElementRef = React.useRef(null);

  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }

    AmenitiesListing();
  }, [open]);
  // End

  async function AmenitiesListing() {
    let bodyFormData = {
      searchq: "",
      pageNo: "",
      count: "",
      status: "",
    };

    makePostRequest("amenities/bookedamenitieslisting", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log(response.data.data.rowCount);
          const data = response.data.data.rows;
          console.log(data);
          setAmenitiesList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid
          container
          spacing={3}
          className="mainHeadingLine AmenitiesOuterMain"
        >
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Booked Amenities</h1>

            {/* <Button
              className="contentTopLefBt"
              onClick={handleClickOpen("body")}
            >
              Add Amenity
            </Button> */}
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="visitorListNewOut">
                <div className="visitorHead">Booked Amenities</div>
                <div className="visitorListNewInner bookedAmeniTabMain">
                  <div>
                    <div className="invoicePaidUnpaidTabMain">
                      <Box sx={{ width: "100%" }}>
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                          <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="basic tabs example"
                            variant="scrollable"
                            scrollButtons
                            allowScrollButtonsMobile
                          >
                            <Tab label="Booked Amenities" {...a11yProps(0)} />
                            <Tab label="Rejected Amenities" {...a11yProps(1)} />
                            <Tab label="Pending Amenities" {...a11yProps(2)} />
                          </Tabs>
                        </Box>
                        <div className="bookedAmeniTabContent">
                          <TabPanel value={value} index={0}>
                            <div className="visitorSearch">
                              <div className="visitorSearchDiv">
                                <SearchIcon className="visitorSearchIco" />
                                <input type="text" placeholder="Search" />
                                <MicIcon className="visitorMicIco" />
                              </div>
                            </div>
                            {amenitiesList.map((option) => {
                              <div className="visitContDiv">
                                <div className="visitContProf">
                                  <Zoom>
                                    <img src="https://www.nobroker.in/blog/wp-content/uploads/2022/07/Front-And-Back-Door-Layouts-Of-A-Modest-Home-1.jpg" />
                                  </Zoom>
                                </div>
                                <div className="visitCont1 resideNewContOut">
                                  <div className="visitContLeft">
                                    <h3 className="visitContHed">
                                      Multipurpose Hall
                                    </h3>
                                    <p className="visitContTime">
                                      Booking date: 7/3/2023
                                    </p>
                                  </div>
                                  <div className="visitBottCont">
                                    <p>Booking timeslote</p>
                                    <b>12:00pm To 3:30pm</b>
                                  </div>
                                  <div className="resideNewCont">
                                    <b>3500/-</b>
                                  </div>
                                </div>
                                <div className="visitCont2">
                                  <div className="visitBottCont">
                                    <p>Booked by:</p>
                                    <b>Prakash jha (Wing A-502)</b>
                                  </div>
                                </div>
                              </div>;
                            })}
                            <div className="visitContDiv">
                              <div className="visitContProf">
                                <Zoom>
                                  <img src="https://www.nobroker.in/blog/wp-content/uploads/2022/07/Front-And-Back-Door-Layouts-Of-A-Modest-Home-1.jpg" />
                                </Zoom>
                              </div>
                              <div className="visitCont1 resideNewContOut">
                                <div className="visitContLeft">
                                  <h3 className="visitContHed">
                                    Multipurpose Hall
                                  </h3>
                                  <p className="visitContTime">
                                    Booking date: 7/3/2023
                                  </p>
                                </div>
                                <div className="visitBottCont">
                                  <p>Booking timeslote</p>
                                  <b>12:00pm To 3:30pm</b>
                                </div>
                                <div className="resideNewCont">
                                  <b>3500/-</b>
                                </div>
                              </div>
                              <div className="visitCont2">
                                <div className="visitBottCont">
                                  <p>Booked by:</p>
                                  <b>Prakash jha (Wing A-502)</b>
                                </div>
                              </div>
                            </div>
                          </TabPanel>

                          <TabPanel value={value} index={1}>
                            <div className="visitorSearch">
                              <div className="visitorSearchDiv">
                                <SearchIcon className="visitorSearchIco" />
                                <input type="text" placeholder="Search" />
                                <MicIcon className="visitorMicIco" />
                              </div>
                            </div>
                            {amenitiesList.map((option) => {
                              <div className="visitContDiv">
                                <div className="visitContProf">
                                  <Zoom>
                                    <img src="https://www.nobroker.in/blog/wp-content/uploads/2022/07/Front-And-Back-Door-Layouts-Of-A-Modest-Home-1.jpg" />
                                  </Zoom>
                                </div>
                                <div className="visitCont1 resideNewContOut">
                                  <div className="visitContLeft">
                                    <h3 className="visitContHed">
                                      Multipurpose Hall
                                    </h3>
                                    <p className="visitContTime">
                                      Booking date: 7/3/2023
                                    </p>
                                  </div>
                                  <div className="visitBottCont">
                                    <p>Booking timeslote</p>
                                    <b>12:00pm To 3:30pm</b>
                                  </div>
                                  <div className="resideNewCont">
                                    <b>3500/-</b>
                                  </div>
                                </div>
                                <div className="visitCont2">
                                  <div className="visitBottCont">
                                    <p>Booked by:</p>
                                    <b>Prakash jha (Wing A-502)</b>
                                  </div>
                                </div>
                              </div>;
                            })}
                            <div className="visitContDiv">
                              <div className="visitContProf">
                                <Zoom>
                                  <img src="https://www.nobroker.in/blog/wp-content/uploads/2022/07/Front-And-Back-Door-Layouts-Of-A-Modest-Home-1.jpg" />
                                </Zoom>
                              </div>
                              <div className="visitCont1 resideNewContOut">
                                <div className="visitContLeft">
                                  <h3 className="visitContHed">
                                    Multipurpose Hall
                                  </h3>
                                  <p className="visitContTime">
                                    Booking date: 7/3/2023
                                  </p>
                                </div>
                                <div className="visitBottCont">
                                  <p>Booking timeslote</p>
                                  <b>12:00pm To 3:30pm</b>
                                </div>
                                <div className="resideNewCont">
                                  <b>3500/-</b>
                                </div>
                              </div>
                              <div className="visitCont2">
                                <div className="visitBottCont">
                                  <p>Booked by:</p>
                                  <b>Prakash jha (Wing A-502)</b>
                                </div>
                              </div>
                            </div>
                          </TabPanel>

                          <TabPanel value={value} index={2}>
                            <div className="visitorSearch">
                              <div className="visitorSearchDiv">
                                <SearchIcon className="visitorSearchIco" />
                                <input type="text" placeholder="Search" />
                                <MicIcon className="visitorMicIco" />
                              </div>
                            </div>
                            {amenitiesList.map((option) => {
                              <div className="visitContDiv">
                                <div className="visitContProf">
                                  <Zoom>
                                    <img src="https://www.nobroker.in/blog/wp-content/uploads/2022/07/Front-And-Back-Door-Layouts-Of-A-Modest-Home-1.jpg" />
                                  </Zoom>
                                </div>
                                <div className="visitCont1 resideNewContOut">
                                  <div className="visitContLeft">
                                    <h3 className="visitContHed">
                                      Multipurpose Hall
                                    </h3>
                                    <p className="visitContTime">
                                      Booking date: 7/3/2023
                                    </p>
                                  </div>
                                  <div className="visitBottCont">
                                    <p>Booking timeslote</p>
                                    <b>12:00pm To 3:30pm</b>
                                  </div>
                                  <div className="resideNewCont">
                                    <b>3500/-</b>
                                  </div>
                                </div>
                                <div className="visitCont2">
                                  <div className="visitBottCont">
                                    <p>Booked by:</p>
                                    <b>Prakash jha (Wing A-502)</b>
                                  </div>
                                </div>
                              </div>;
                            })}
                            <div className="visitContDiv">
                              <div className="visitContProf">
                                <Zoom>
                                  <img src="https://www.nobroker.in/blog/wp-content/uploads/2022/07/Front-And-Back-Door-Layouts-Of-A-Modest-Home-1.jpg" />
                                </Zoom>
                              </div>
                              <div className="visitCont1 resideNewContOut">
                                <div className="visitContLeft">
                                  <h3 className="visitContHed">
                                    Multipurpose Hall
                                  </h3>
                                  <p className="visitContTime">
                                    Booking date: 7/3/2023
                                  </p>
                                </div>
                                <div className="visitBottCont">
                                  <p>Booking timeslote</p>
                                  <b>12:00pm To 3:30pm</b>
                                </div>
                                <div className="resideNewCont">
                                  <b>3500/-</b>
                                </div>
                              </div>
                              <div className="visitCont2">
                                <div className="visitBottCont">
                                  <p>Booked by:</p>
                                  <b>Prakash jha (Wing A-502)</b>
                                </div>
                              </div>
                            </div>
                          </TabPanel>
                        </div>
                      </Box>
                    </div>
                  </div>

                  {/* <div className="visitorSearch">
                    <div className="visitorSearchDiv">
                      <SearchIcon className="visitorSearchIco" />
                      <input type="text" placeholder="Search" />
                      <MicIcon className="visitorMicIco" />
                    </div>
                    <SortIcon
                      className="visitorFilterIco"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      onClick={handleClick}
                    />
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open2}
                      onClose={handleClose2}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem onClick={() => navigate("/BookedAmenities")}>
                        Booked Amenities
                      </MenuItem>
                      <MenuItem onClick={() => navigate("/RejectedAmenities")}>
                        Rejected Amenities
                      </MenuItem>
                      <MenuItem onClick={() => navigate("/PendingAmenities")}>
                        Pending Amenities
                      </MenuItem>
                    </Menu>
                  </div>
                  {amenitiesList.map((option) => {
                    <div className="visitContDiv">
                      <div className="visitContProf">
                        <Zoom>
                          <img src="https://www.nobroker.in/blog/wp-content/uploads/2022/07/Front-And-Back-Door-Layouts-Of-A-Modest-Home-1.jpg" />
                        </Zoom>
                      </div>
                      <div className="visitCont1 resideNewContOut">
                        <div className="visitContLeft">
                          <h3 className="visitContHed">Multipurpose Hall</h3>
                          <p className="visitContTime">
                            Booking date: 7/3/2023
                          </p>
                        </div>
                        <div className="visitBottCont">
                          <p>Booking timeslote</p>
                          <b>12:00pm To 3:30pm</b>
                        </div>
                        <div className="resideNewCont">
                          <b>3500/-</b>
                        </div>
                      </div>
                      <div className="visitCont2">
                        <div className="visitBottCont">
                          <p>Booked by:</p>
                          <b>Prakash jha (Wing A-502)</b>
                        </div>
                      </div>
                    </div>;
                  })}
                  <div className="visitContDiv">
                    <div className="visitContProf">
                      <Zoom>
                        <img src="https://www.nobroker.in/blog/wp-content/uploads/2022/07/Front-And-Back-Door-Layouts-Of-A-Modest-Home-1.jpg" />
                      </Zoom>
                    </div>
                    <div className="visitCont1 resideNewContOut">
                      <div className="visitContLeft">
                        <h3 className="visitContHed">Multipurpose Hall</h3>
                        <p className="visitContTime">Booking date: 7/3/2023</p>
                      </div>
                      <div className="visitBottCont">
                        <p>Booking timeslote</p>
                        <b>12:00pm To 3:30pm</b>
                      </div>
                      <div className="resideNewCont">
                        <b>3500/-</b>
                      </div>

                      
                    </div>
                    <div className="visitCont2">
                      <div className="visitBottCont">
                        <p>Booked by:</p>
                        <b>Prakash jha (Wing A-502)</b>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Amenity</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <AmenitiesModal />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default BookedAmenities;
